export const languagesCodesSelect = [
  { name: 'English (U.S.)', value: 'en_US' },
  { name: '中文（简体）Chinese (Simplified)', value: 'zh_CN' },
  { name: '中文（繁體） Chinese (Traditional)', value: 'zh_TW' },
  { name: '日本語 (Japanese)', value: 'ja_JP' },
  { name: '한국어 (Korean)', value: 'ko_KR' },
];

export const codesLanguages = {
  en_US: 'English (U.S.)',
  zh_CN: '中文（简体）Chinese (Simplified)',
  zh_TW: '中文（繁體） Chinese (Traditional)',
  ja_JP: '日本語 (Japanese)',
  ko_KR: '한국어 (Korean)',
};

export default codesLanguages;
